import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import UploadService from "./upload-files.service";
import axios from "../../../../api/axios";
import {
  Paper,
  Box,
  Grid,
  Typography,
  responsiveFontSizes,
  TextField,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import { url } from "../../../../configlink";
import { useSelector } from "react-redux";

const UploadFiles = () => {
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [progressInfos, setProgressInfos] = useState({ val: [] });
  const [message, setMessage] = useState([]);
  const [fileInfos, setFileInfos] = useState([]);
  const progressInfosRef = useRef(null);

	let adminUser = useSelector((state) => state.userAdmin.userAdmin)
  // useEffect(() => {
  //   /*UploadService.getFiles().then(response => {
  //     setFileInfos(response.data);
  //   });
  //   */
  // }, []);

  
  const selectFiles = (event) => {
    setSelectedFiles(event.target.files);
    setProgressInfos({ val: [] });
  };

  const upload = async (idx, file) => {
    let arrFile = file.name.split(".");
    if (arrFile.length !== 2) return;

    // alert('just file name===' + arrFile[0]);

    let userId = 0;
    let mode = "invoice";

  
    console.log("sub step 11");
    try {
      const response = await axios.get(
        `${url}/api/admin/get_userid_by_orderid`,
        {
          params: { orderId: arrFile[0] },
			withCredentials: true,
			headers: {
				'acgt-admin': adminUser
			},
        }
      );
      console.log("orderid1=" + arrFile[0]);
      console.log("RESPONSE", response)

      // if (response[0].data !== "" && response[0].data.UserId !== undefined) {
      if (response) {
        userId = response.data.UserId;
        console.log("userid=" + userId);
      }
    } catch (error) {
      console.log(error);
    }

    let _progressInfos = [...progressInfosRef.current.val];
    return UploadService.upload(file, arrFile[0], userId, mode, (event) => {
      _progressInfos[idx].percentage = Math.round(
        (100 * event.loaded) / event.total
      );
      setProgressInfos({ val: _progressInfos });
    })
      .then(() => {
        setMessage((prevMessage) => [
          ...prevMessage,
          "Uploaded the file successfully: " + file.name,
        ]);
      })
      .catch(() => {
        _progressInfos[idx].percentage = 0;
        setProgressInfos({ val: _progressInfos });

        setMessage((prevMessage) => [
          ...prevMessage,
          "Could not upload the file: " + file.name,
        ]);
      });
  };

  const uploadFiles = (event) => {
    event.preventDefault(); 
	const files2 = Array.from(selectedFiles);
	
	const files = files2.map((f) => {
		
		let newName = f.name.replace(/^Invoice\s+/, "");
	
		return new File(
			[f],          // file data
			newName,         // new filename
			{ type: f.type }
		);
	})
	
    console.log("file length=" + files.length);
    let _progressInfos = files.map((file) => ({
		percentage: 0,
		fileName: file.name,
    }));

    progressInfosRef.current = {
      val: _progressInfos,
    };

    try {
      const uploadPromises = files.map((file, i) => upload(i, file));

      Promise.all(uploadPromises).then((files) => {
        setFileInfos(files.data);
      });
    } catch (error) {
      console.log(error);
      // Expected output: ReferenceError: nonExistentFunction is not defined
      // (Note: the exact output may be browser-dependent)
    }
    setMessage([]);
  };

  const divStyle = {
    overflowY: "scroll",
    // width: "670px",
    width: "100%",
    float: "left",
    height: "300px",
  };

  return (
    <div>
      <Divider orientation='horizontal' flexItem style={{ width: "60%" }} />

      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Box sx={{ my: 3, mx: 2 }}>
          <Grid container alignItems='center' spacing={1}>
            <Grid item xs>
              {/* any elements nested inside the role="presentation" preserve their semantics. */}
              <Typography gutterBottom variant='h4' component='div' style={{color: 'var(--color-primary-purple)'}}>
                Upload Invoice Files
              </Typography>
            </Grid>
          </Grid>

          <Divider component='div' role='presentation' />

          <Grid container alignItems='center' spacing={1}>
            <Grid item xs>
              <Typography color='text.secondary' variant='body2'>
                Please do not make sub folder since it just can upload the
                invoices on the chosen folder
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ marginTop: 3 }}>
          <Grid container style={{ display:'flex', justifyContent:'center', alignItems:'center', gap:'50px', width:'90%'}}>
            <Grid item >
              <input type='file' multiple onChange={selectFiles} />
            </Grid>
            <Grid item>
              <button
                className={`text-white ${selectedFiles ? 'bg-[var(--color-primary-purple)]': 'bg-gray-500'} px-4 py-1 rounded-md`}
                disabled={!selectedFiles}
                onClick={uploadFiles}
              >
                Upload
              </button>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <div className='row my-10' style={divStyle}>
        {progressInfos &&
          progressInfos.val.length > 0 &&
          progressInfos.val.map((progressInfo, index) => (
            <div className='mb-2' key={index}>
              <Typography color='text.secondary' variant='body2'>
                {progressInfo.fileName}
              </Typography>
              <div className='progress'>
                <div
                  className='progress-bar progress-bar-info'
                  role='progressbar'
                  aria-valuenow={progressInfo.percentage}
                  aria-valuemin='0'
                  aria-valuemax='100'
                  style={{ width: progressInfo.percentage + "%", backgroundColor:'var(--color-primary-purple)' }}
                >
                  {progressInfo.percentage}%
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default UploadFiles;
